const preventedEvents = new WeakSet<MouseEvent>();

/**
 * Prevent the block selection (SHIFT + Click in a block) from occurring.
 */
export function preventBlockSelection(event: MouseEvent) {
    preventedEvents.add(event);
}

/**
 * Check if the block selection is prevented.
 */
export function isBlockSelectionPrevented(event: MouseEvent) {
    return preventedEvents.has(event);
}
